import { Alert, AlertIcon, Box, Text } from "@chakra-ui/react";
import { resolveNotificationLangKey } from "../../constants/lang";
import type { CoverageViolationDetail } from "../../types/rfx-notification-mgmt.types";

export interface CoverageBannerProps {
	violations: CoverageViolationDetail[];
}

// AC2/AC3 (409 dynamic reduce): per-bidder-org warnings shown before save when
// a rule change would reduce a bidder org below its guarantee — server-authoritative,
// the violations here are exactly what the 107 CoverageGuard simulation returned.
export const CoverageBanner = ({ violations }: CoverageBannerProps) => {
	if (violations.length === 0) {
		return null;
	}

	return (
		<Alert status="warning" data-testid="coverage-banner">
			<AlertIcon />
			<Box>
				{violations.map((violation) => (
					<Text key={`${violation.type_key}-${violation.message}`}>
						{resolveNotificationLangKey(violation.message)}
					</Text>
				))}
			</Box>
		</Alert>
	);
};
